import { ACTION_TYPE, FanAction } from '../actions/fandom'
import { Fan } from '../public/models/fan'
import { Status } from '@owl-nest/redux-wrapper'

export type State = {
  userIsAFollower: boolean
  fans: Fan[]
  next: string | null
  count: number
  status: {
    load: Status
  }
}

export const initialState: State = {
  userIsAFollower: false,
  fans: [],
  next: null,
  count: 0,
  status: {
    load: Status.PRISTINE,
  },
}

export function reducer(state = initialState, action: FanAction): State {
  switch (action.type) {
    case ACTION_TYPE.TOGGLE_USER_STATUS:
      return {
        ...state,
        userIsAFollower: action.isFollowing,
      }
    case ACTION_TYPE.LOAD_FANS_REQUEST: {
      return {
        ...state,
        status: {
          ...state.status,
          load: Status.PENDING,
        },
      }
    }
    case ACTION_TYPE.LOAD_FANS_FAILURE: {
      return {
        ...state,
        fans: [],
        next: null,
        status: {
          ...state.status,
          load: Status.FAILURE,
        },
      }
    }
    case ACTION_TYPE.LOAD_FANS_SUCCESS: {
      if (action.success.forceClean) {
        return {
          ...state,
          fans: action.success.fans ?? [],
          next: action.success.meta.next,
          count: action.success.meta.total_count,
          status: {
            ...state.status,
            load: Status.SUCCESS,
          },
        }
      }
      return {
        ...state,
        fans: state.fans.concat(action.success.fans ?? []),
        next: action.success.meta.next,
        count: action.success.meta.total_count,
        status: {
          ...state.status,
          load: Status.SUCCESS,
        },
      }
    }
    default:
      return state
  }
}
